import { render, staticRenderFns } from "./DuyetNguoiDung.vue?vue&type=template&id=23f90bd4&scoped=true"
import script from "./DuyetNguoiDung.vue?vue&type=script&lang=ts"
export * from "./DuyetNguoiDung.vue?vue&type=script&lang=ts"
import style0 from "./DuyetNguoiDung.vue?vue&type=style&index=0&id=23f90bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f90bd4",
  null
  
)

export default component.exports